enum colorCodeEnum {
  Red,
  Green,
  Yellow,
  Blue,
  Magenta,
  Cyan,
  White,
}

export default colorCodeEnum;
